import React from "react";

/**
 * BrandLogo — Paul Vilas signature logo (transparent PNG).
 *
 * Renders the YELLOW signature on dark surfaces and the BLACK signature on
 * light surfaces. Replaces the previous `<span className="font-signature">Paul Vilas</span>`
 * pattern across the app.
 *
 * Props:
 *  - variant: "yellow" (default) | "black"
 *  - className: extra classes on the <img> — mostly used to control height (e.g. `h-8`)
 *  - alt: defaults to "Paul Vilas"
 */
const SRC = {
  yellow: "/brand/paul-vilas-yellow.png",
  black: "/brand/paul-vilas-black.png",
};

export default function BrandLogo({ variant = "yellow", className = "h-8", alt = "Paul Vilas", ...rest }) {
  return (
    <img
      src={SRC[variant] || SRC.yellow}
      alt={alt}
      data-testid={`brand-logo-${variant}`}
      className={`w-auto select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
}
